module.exports = __webpack_public_path__ + "static/product-ac30-olive-drab-c3ca870b7750b0633651bc0e3f5064d0.png";